module.exports = __webpack_public_path__ + "img/public/SiteIcons/locatiionPin.svg?ed512f0a";